import { ChangeEvent, forwardRef } from 'react';
import classNames from 'classnames';

export interface InlineUnderlinedInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  hasError?: boolean;
  helperMessage?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const InlineUnderlinedInput = forwardRef<HTMLInputElement, InlineUnderlinedInputProps>(
  ({ className, hasError, helperMessage, onChange, ...props }, ref) => {
    return (
      <input
        {...props}
        ref={ref}
        type={props.type ?? 'text'}
        className={classNames(
          'w-full bg-primary border-0 text-body-s focus:outline-hidden focus:ring-0 px-0 pt-0 pb-1',
          'placeholder:text-secondary placeholder:text-body-s',
          {
            'border-hard text-primary border-b': !hasError,
            'border-critical-no-bg text-primary border-b-2': !!hasError,
          },
          className
        )}
        onChange={onChange}
      />
    );
  }
);
